module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy_wrap"
  }, [_c('h2', {
    on: {
      "click": _vm.fold
    }
  }, [_vm._v(_vm._s(_vm.title) + "\n    "), _c('span', {
    class: {
      down: !_vm.onOff
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.onOff),
      expression: "onOff"
    }]
  }, [_c('p', [_vm._v(_vm._s(_vm.partOne))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.partTwo))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.partTh))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76120e0d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/fold.vue
// module id = 860
// module chunks = 1